import menuumkmApi from '../../services/menuumkmApi'

const SET_MENU_UMKM = "SET_MENU_UMKM"

const state = {
	menuumkm: []
}

const mutations = {
	[SET_MENU_UMKM](state, data) {
		state.menuumkm = data
	}
}

const actions = {
	async fetchMenuUmkm({ getters }) {
		let token = getters.getAuthService.token
		return await menuumkmApi.fetchMenuUmkm(token)
	},
	async fetchMenuUmkmReady({ getters }) {
		let token = getters.getAuthService.token
		return await menuumkmApi.fetchMenuUmkmReady(token)
	},
	async storeMenuUmkm({ getters }, data) {
		let token = getters.getAuthService.token
		return await menuumkmApi.storeMenuUmkm(token, data)
	},
	async showMenuUmkm({ getters }, id) {
		let token = getters.getAuthService.token
		return await menuumkmApi.showMenuUmkm(token, id)
	},
	async updateMenuUmkm({ getters }, data) {
		let token = getters.getAuthService.token
		return await menuumkmApi.updateMenuUmkm(token, data.id, data.form)
	},
	async updateStatusMenuUmkm({ getters }, data) {
		let token = getters.getAuthService.token
		return await menuumkmApi.updateStatusMenuUmkm(token, data.id, data.form)
	},
	async destroyMenuUmkm({ getters }, id) {
		let token = getters.getAuthService.token
		return await menuumkmApi.destroyMenuUmkm(token, id)
	}
}

const getters = {
	getMenuUmkm: state => {
		return state.menuumkm
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}